import forEach from 'lodash/forEach';
import { mean, std } from 'mathjs';
import { isAggregatedPreMeal } from 'libs/StatsCalculations';
import { calculateRelatedValue } from 'helpers/relatedData';
export function calculateData(readings) {
    const preMealReadings = [];
    const postMealReadings = [];
    const strictPostMealReadings = [];
    forEach(readings, (item)=>{
        if (isAggregatedPreMeal(item.flags)) {
            preMealReadings.push(item);
        } else {
            postMealReadings.push(item);
        }
        if (item.flags === 'PostMeal') {
            strictPostMealReadings.push(item);
        }
    });
    return {
        preMealReadings,
        postMealReadings,
        strictPostMealReadings
    };
}
export function createReadingsKPIData(readings, conversion, standards) {
    const results = {
        criticalHighReadingsNumber: 0,
        criticalLowReadingsNumber: 0,
        readingsAverage: 0,
        standardDeviation: 0,
        preMealAverage: 0,
        strictPostMealAverage: 0,
        readingsInRange: 0,
        readingsInRangeRatio: 0,
        lowReadingsNumber: 0,
        highReadingsNumber: 0
    };
    const { preMealReadings, postMealReadings, strictPostMealReadings } = calculateData(readings);
    const readingsValues = readings.map((reading)=>reading.value);
    const preMealReadingsValues = preMealReadings.map((reading)=>reading.value);
    const strictPostMealReadingsValues = strictPostMealReadings.map((reading)=>reading.value);
    if (readings && readings.length > 0) {
        results.readingsAverage = mean(readingsValues);
        results.standardDeviation = std(readingsValues);
    }
    if (preMealReadings && preMealReadings.length > 0) {
        preMealReadings.forEach((reading)=>{
            if (standards) {
                if (standards.preMeal.lowThreshold > reading.value) {
                    results.lowReadingsNumber += 1;
                } else if (standards.preMeal.highThreshold < reading.value) {
                    results.highReadingsNumber += 1;
                }
                if (standards.critical.lowThreshold > reading.value) {
                    results.criticalLowReadingsNumber += 1;
                } else if (standards.critical.highThreshold < reading.value) {
                    results.criticalHighReadingsNumber += 1;
                }
            }
        });
        if (preMealReadingsValues.length) {
            results.preMealAverage = mean(preMealReadingsValues);
        }
    }
    if (postMealReadings && postMealReadings.length > 0) {
        postMealReadings.forEach((reading)=>{
            if (standards) {
                if (standards.postMeal.lowThreshold > reading.value) {
                    results.lowReadingsNumber += 1;
                } else if (standards.postMeal.highThreshold < reading.value) {
                    results.highReadingsNumber += 1;
                }
                if (standards.critical.lowThreshold > reading.value) {
                    results.criticalLowReadingsNumber += 1;
                } else if (standards.critical.highThreshold < reading.value) {
                    results.criticalHighReadingsNumber += 1;
                }
            }
        });
        if (strictPostMealReadingsValues.length) {
            results.strictPostMealAverage = mean(strictPostMealReadingsValues);
        }
    }
    results.variability = results.readingsAverage ? (std(readingsValues, 'uncorrected') / results.readingsAverage).toFixed(1) : null;
    results.readingsAverage = conversion.toDisplay(results.readingsAverage);
    results.strictPostMealAverage = conversion.toDisplay(results.strictPostMealAverage);
    results.preMealAverage = conversion.toDisplay(results.preMealAverage);
    results.standardDeviation = conversion.toDisplay(results.standardDeviation);
    const readingsOutOfRange = results.lowReadingsNumber + results.highReadingsNumber;
    results.readingsInRangeRatio = readings.length ? ((readings.length - readingsOutOfRange) / readings.length * 100).toFixed(0) : 0;
    return results;
}
export function calculateMedicationsKPIData(relatedDataList, translatedTimeSeriesResources) {
    let medicationFastValues = 0;
    let medicationLongValues = 0;
    relatedDataList.forEach((relatedData)=>{
        const { medicationFastValue, medicationLongValue } = calculateRelatedValue(relatedData);
        medicationFastValues += medicationFastValue;
        medicationLongValues += medicationLongValue;
    });
    translatedTimeSeriesResources.forEach((translatedTimeSeriesResource)=>{
        const { medicationFastValue, medicationLongValue } = translatedTimeSeriesResource;
        medicationFastValues += medicationFastValue || 0;
        medicationLongValues += medicationLongValue || 0;
    });
    if (!medicationFastValues && !medicationLongValues) {
        return {
            longActingRatio: null,
            fastActingRatio: null
        };
    }
    const fastActingRatio = +(medicationFastValues / (medicationFastValues + medicationLongValues) * 100).toFixed(0);
    const longActingRatio = 100 - fastActingRatio;
    return {
        longActingRatio,
        fastActingRatio
    };
}
